export default {"src":"/_next/static/media/contactUs.e83f9452.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};